import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCardState'
})
export class FilterCardStatePipe implements PipeTransform {

  transform(value: any, state: string): any {
    console.log('pipe: ', value)

    let result;

    switch(state) {
      case 'closed':
        result = value.filter(e => e.closeddt != null && new Date(e.closeddt) < new Date());
        break;
      case 'active':
        result = value.filter(e => e.closeddt === null || new Date(e.closeddt) >= new Date());
        break;
      default:
        result = value;
        break;
    }

    return result;
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/pipes/filter-card-state.pipe.ts